export default "__VITE_ASSET__Ct986D0r__"